import type { HostedModuleDetails as GraftHostedModule } from '@graft/nuget-gc.webportals.gateways'

import type { HostedModule } from '../types/gateway.type'

export async function hostedModuleToObject(entity: GraftHostedModule): Promise<HostedModule> {
  const [name, version, feedProtocol, feedType, description] = await Promise.all([
    entity.get_name(),
    entity.get_version(),
    entity.get_feedProtocol(),
    entity.get_feedType(),
    entity.get_description(),
  ])
  return {
    name,
    version,
    feedProtocol,
    feedType,
    description,
  }
}
